import { render, staticRenderFns } from "./SsoLogin.vue?vue&type=template&id=389e933a&scoped=true"
import script from "./SsoLogin.vue?vue&type=script&lang=js"
export * from "./SsoLogin.vue?vue&type=script&lang=js"
import style0 from "./SsoLogin.vue?vue&type=style&index=0&id=389e933a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e933a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389e933a')) {
      api.createRecord('389e933a', component.options)
    } else {
      api.reload('389e933a', component.options)
    }
    module.hot.accept("./SsoLogin.vue?vue&type=template&id=389e933a&scoped=true", function () {
      api.rerender('389e933a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/SsoLogin.vue"
export default component.exports